import { defineStore } from 'pinia';

export const LoadingStore = defineStore('LoadingStore', {
  state: () => ({
    counter: 0,
  }),
  getters: {
    /**
     * データ取得中状態であるかをチェックします
     */
    isLoadingData(state) {
      return state.counter > 0;
    },
  },
  actions: {
    countUp() {
      this.$state.counter += 1;
    },
    countDown() {
      this.$state.counter -= 1;
    },
    countReset() {
      this.$reset();
    },
  },
  // ローディング制御なので変な状態の場合はリロードでリセットされて然るべきのためpersist
  // persist: {
  //   enabled: true,
  // },
});
